export default __webpack_public_path__ + "73436eff2a8ac77e97b6c01fa5dc5abf.svg";